import { flow } from "fp-ts/lib/function";

import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { getInsightsDiffPctCurried } from "../math";
import { type InsightsMetrics, type StatsItem } from "../models";

export const mapDiffValue =
    (metricPrevious: InsightsMetrics<StatsItem> | undefined) =>
    (metric: InsightsMetrics<StatsItem> | undefined): InsightsMetrics<StatsItem> | undefined => {
        if (!metric) {
            return undefined;
        }

        return metricPrevious
            ? {
                  ...metric,
                  diffValue: flow(
                      getInsightsDiffPctCurried(metricPrevious.totalValue),
                      formatSignedPctNumber,
                  )(metric.totalValue),
              }
            : metric;
    };
